export enum Status {
    OK = 200,
    NOT_AUTHORIZED = 401,
    NOT_FOUND = 404,
    SERVER_ERROR = 500,
    METHOD_NOT_ALLOWED = 405
}
